import React, { useState } from "react";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PPIService from "../../services/PPIService";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const documentLabels = {
  2: { name: "Name on PAN Card", number: "PAN Number" },
  3: { name: "Name on Passport", number: "File Number" },
  4: { name: "Name on Driving License", number: "DL Number" },
  5: { name: "Name on Voter ID", number: "Voter ID Number" },
};

const states = [
  { code: "AN", name: "Andaman and Nicobar Islands" },
  { code: "AP", name: "Andhra Pradesh" },
  { code: "AR", name: "Arunachal Pradesh" },
  { code: "AS", name: "Assam" },
  { code: "BR", name: "Bihar" },
  { code: "CH", name: "Chandigarh UT" },
  { code: "CG", name: "Chhattisgarh" },
  { code: "DN", name: "Dadra & Nagar Haveli" },
  { code: "DD", name: "Daman & Diu" },
  { code: "DL", name: "Delhi" },
  { code: "GA", name: "Goa" },
  { code: "GJ", name: "Gujarat" },
  { code: "HR", name: "Haryana" },
  { code: "HP", name: "Himachal Pradesh" },
  { code: "JK", name: "Jammu & Kashmir" },
  { code: "JH", name: "Jharkhand" },
  { code: "KA", name: "Karnataka" },
  { code: "KL", name: "Kerala" },
  { code: "LD", name: "Lakshadweep" },
  { code: "MP", name: "Madhya Pradesh" },
  { code: "MH", name: "Maharashtra" },
  { code: "MN", name: "Manipur" },
  { code: "ML", name: "Meghalaya" },
  { code: "MZ", name: "Mizoram" },
  { code: "NL", name: "Nagaland" },
  { code: "OR", name: "Orissa" },
  { code: "PY", name: "Pondicherry UT" },
  { code: "PB", name: "Punjab" },
  { code: "RJ", name: "Rajasthan" },
  { code: "SK", name: "Sikkim" },
  { code: "TN", name: "Tamil Nadu" },
  { code: "TS", name: "Telangana" },
  { code: "TR", name: "Tripura" },
  { code: "UP", name: "Uttar Pradesh" },
  { code: "UA", name: "Uttarakhand" },
  { code: "WB", name: "West Bengal" },
];

const MinKycVerifyDocument = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { verificationToken } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const [nameOnDocument, setNameOnDocument] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [dob, setDob] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [state, setState] = useState("");

  const verifyDocumentHandler = async () => {
    setLoading(true);
    try {
      const result = await PPIService.verifyMinKycDocument(
        verificationToken,
        parseInt(documentType),
        nameOnDocument,
        documentNumber,
        dob || undefined,
        issueDate || undefined,
        state || undefined
      );

      if (!result.success) {
        return Swal.fire(
          "Oops!",
          result.message || "Failed to verify",
          "error"
        );
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        // Swal.fire("Success!", responseData.message, "success");
        // Redirect
        navigate("/issue-digital-card");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const showDOB = ["2", "3", "4"].includes(documentType);
  const showIssueDate = documentType === "4";
  const showState = documentType === "5";

  return (
    <React.Fragment>
      <Header />

      <div className="bg-light py-3 px-3  d-flex align-items-center justify-content-center">
        <div className="card rounded-4 w-100" style={{ maxWidth: "1200px" }}>
          <div className="card-body p-4">
            <h4 className="mb-4 text-center">
              PPI User Onboarding | Verify MIN KYC Document
            </h4>

            <div className="mb-3">
              <label className="form-label">Document Type</label>
              <select
                className="form-control"
                value={documentType}
                onChange={(e) => setDocumentType(e.target.value)}
              >
                <option value="">Select Document Type</option>
                <option value="2">PAN CARD</option>
                <option value="3">PASSPORT</option>
                <option value="4">DRIVING LICENSE</option>
                <option value="5">VOTER ID</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">
                {documentLabels[documentType]?.name || "Name on Document"}
              </label>
              <input
                type="text"
                className="form-control"
                value={nameOnDocument}
                onChange={(e) => setNameOnDocument(e.target.value)}
                placeholder={
                  documentLabels[documentType]?.name || "Name as per Document"
                }
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                {documentLabels[documentType]?.number || "Document Number"}
              </label>
              <input
                type="text"
                className="form-control"
                value={documentNumber}
                onChange={(e) => setDocumentNumber(e.target.value)}
                placeholder={
                  documentLabels[documentType]?.number ||
                  "Enter Document Number"
                }
              />
            </div>

            {showDOB && (
              <div className="mb-3">
                <label className="form-label">Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                />
              </div>
            )}

            {showIssueDate && (
              <div className="mb-3">
                <label className="form-label">Issue Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={issueDate}
                  onChange={(e) => setIssueDate(e.target.value)}
                />
              </div>
            )}

            {showState && (
              <div className="mb-3">
                <label className="form-label">State</label>
                <select
                  className="form-control"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                >
                  <option value="">Select State</option>
                  {states.map((s) => (
                    <option key={s.code} value={s.code}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <button
              className="btn btn-primary w-100"
              onClick={verifyDocumentHandler}
              disabled={loading}
            >
              {loading ? "Processing..." : "Verify"}
            </button>

            <hr className="mt-4" />
            <div className="text-center">
              <small className="text-muted d-block mb-1">ISSUED BY</small>
              <img
                src="/images/pine-labs-logo.png"
                alt="Pine Labs"
                style={{ height: "22px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default MinKycVerifyDocument;
